import React from 'react';
import { Card } from "react-bootstrap";
import face_zsombor_berezvai from "../../assets/img/face_orsolya_vasarhelyi.jpg";
import ShowMoreText from "react-show-more-text";
import proj_fairness_of_LLMS from "../../assets/img/proj_fairness_of_LLMS.png";

const Orsolya_Vasarhelyi_fairness_of_LLMS = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_fairness_of_LLMS} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_zsombor_berezvai}
              /* this will be the text on the banner */
              alt="Fairness of LLMs in scientific research"
            />{" "}
            <p className="text7">Orsolya Vásárhelyi</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            <p className="text8">Center for Collective Learning, Corvinus University in Budapest </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            The use of Large Language Models (LLM) (e.g., ChatGPT) is becoming widespread in text 
            editing and academic research. The premise that such services can support the scientific 
            community in discovering new scientific advancements and reviewing field-specific 
            literature faster is intriguing. Although it can facilitate cost-effective text generation 
            and editing, it has the tendency to provide factually incorrect responses, so called 
            hallucinations. Furthermore, we have very limited knowledge about the criteria based on 
            which LLM selects certain publications for inclusion in the generated reviews and whether 
            the resulting text accurately represents the scientific community in terms of scientific 
            impact, online visibility, geography, gender, ethnicity, language, and so on. This project 
            aims to develop a framework for evaluating the fairness and accuracy of Large Language Models 
            (LLMs) in assisting scientists by generating literature reviews for existing publications and 
            comparing the resulting citations with the ground truth dataset. Participants can gain practice 
            in data collection using various APIs, prompt engineering for LLMs, and learn about applied 
            fairness metrics. Basic programming skills are required to participate.
            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                <a href="https://www.nature.com/articles/s41598-023-41032-5">
                Walters, W.H., Wilder, E.I. Fabrication and errors in the bibliographic citations generated 
                by ChatGPT. Sci Rep 13, 14045 (2023).</a>
                </li>
                <li>
                Alkaissi, Hussam, and Samy I. McFarlane. "Artificial hallucinations in ChatGPT: 
                implications in scientific writing." Cureus 15.2 (2023).
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Orsolya_Vasarhelyi_fairness_of_LLMS;